import React from 'react'

import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'
import _ from 'lodash'

import { FlatList, ListRenderItemInfo, TouchableOpacity } from 'react-native'

import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import {
  IInventoryQtyAdjustRequestBody,
  IQtyAdjustmentDetailViewProps,
  IQtyAdjustmentDetailViewState,
  IQtyAdjustProductItem,
  ISearchProductItem,
} from 'x/index'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XCard from 'xui/components/XCard'
import XIcon from 'xui/components/XIcon'
import XSpinner from 'xui/components/XSpinner'
import XInput from 'xui/components/XInput'
import XIconButton from 'xui/components/XIconButton'
import time from 'x/utils/time'

class QtyAdjustmentDetailView extends React.Component<IQtyAdjustmentDetailViewProps, IQtyAdjustmentDetailViewState> {
  static displayName = 'QtyAdjustmentDetailView'

  _inProcess?: boolean

  _isSubmitting?: boolean

  constructor(props: IQtyAdjustmentDetailViewProps) {
    super(props)
    this.state = {
      isInitialized: false,
      isRefreshing: false,

      qtyAdjustmentDetail: null,
    }
  }

  async componentDidMount() {
    await this._initializeView()
    await this._doRefresh()
  }

  _initializeView = async () => {
    await util.setStatePromise(this, { isInitialized: false })
    // Init activeStatesMap
    const newState: Partial<IQtyAdjustmentDetailViewState> = {}
    // get ready to render
    newState.isInitialized = true

    await util.setStatePromise(this, newState)
  }

  _doRefresh = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    await util.setStatePromise(this, { isRefreshing: true })

    await util.delay(100)
    await this._fetchQtyAdjustmentDetail()
    await util.delay(100)

    await util.setStatePromise(this, { isRefreshing: false })
    this._inProcess = false
  }

  _fetchQtyAdjustmentDetail = async () => {
    const store_id = util.getNavParam(this.props, 'store_id')
    const qty_adjustment_history_id = util.getNavParam(this.props, 'qty_adjustment_history_id')

    try {
      const reqParams = { store_id, qty_adjustment_history_id }
      const res = await api.inventoryQtyAdjustDetail(reqParams)
      console.log('_fetchQtyAdjustmentDetail res => ', res)
      if (res && res.qty_adjustment_history_id) {
        await util.setStatePromise(this, { qtyAdjustmentDetail: res })
      }
      // return res
    } catch (error) {
      console.log('_fetchQtyAdjustmentDetail error => ', error)
      // throw error
    }
  }

  _resetView = async () => {
    await util.setStatePromise(this, { isInitialized: false })
    await util.delay(200)
    await this._initializeView()
  }

  _handlePressBackBtn = () => {
    // conditionally go back

    this._navBack()
  }

  _navBack = () => {
    util.navGoBack(this.props)
  }

  _renderCustomHeader = () => (
    // const title = util.getNavParam(this.props, 'title', 'ตรวจสอบ')
    // const title = util.getNavParam(this.props, 'title', `ยืนยันปรับจำนวน${p.op.t('qty')}`)
    // const modifiedTitle = `ตรวจสอบ${title}`
    <XCustomHeader
      // title={title}
      title={this._getTitle()}
      // headerLeftProps={isGoBackButtonHidden ? undefined : { backIcon: true, onPressItem: this._handlePressBackBtn }}
      headerLeftProps={{ backIcon: true, onPressItem: this._handlePressBackBtn }}
      // renderHeaderRight={this._renderSettingIcon}
    />
  )

  _renderListItem = (info: ListRenderItemInfo<IQtyAdjustProductItem>) => {
    const { qtyAdjustmentDetail, searchText } = this.state
    if (!qtyAdjustmentDetail) {
      return null
    }

    const { mode, qty_adjustment_history_id } = qtyAdjustmentDetail

    const { item, index } = info

    if (this.isSearching() && searchText.length > 0) {
      if (!this.isSearchTextMatched(item)) {
        return null
      }
    }

    // const ppQtyChanged = util.getNavParam(this.props, 'ppQtyChanged', {})
    const { pt_name, pp_name, sku, upc, img_url, qty_before, available_qty_before, qty_adjust, pt_id, pp_id } = item
    const productName = pt_name || ''
    const variantName = pp_name || ''
    const imgUri = img_url

    const availableQty = _.isNil(available_qty_before) ? 0 : available_qty_before
    const currentQty = _.isNil(qty_before) ? 0 : qty_before
    const changedQty = currentQty + qty_adjust
    const changedDiff = qty_adjust

    return (
      <VStack
        key={`${qty_adjustment_history_id}_${pt_id}_${pp_id}`}
        w='full'
        // onPress={this.getOnPressListItem(info.item)}
        borderTopWidth={index === 0 ? '0' : '1'}
        // borderTopWidth='1'
        bg={index % 2 === 0 ? undefined : 'gray.100'}
        borderTopColor='muted.300'
      >
        <VStack w='full' p='2' space='1'>
          <HStack w='full' space='1.5'>
            <VStack w='34px' space='2'>
              <XText variant='inactive'>{`#${index + 1}`}</XText>
            </VStack>

            <HStack flex={1} space='1'>
              <XImage source={{ uri: imgUri }} h='64px' w='64px' borderRadius='lg' />
              <VStack flex={1} p='1'>
                <XText variant='inactive' numberOfLines={2}>
                  {productName}
                </XText>

                <XText numberOfLines={2}>{variantName}</XText>

                {sku ? <XText variant='inactive' numberOfLines={1}>{`SKU: ${sku}`}</XText> : null}
                {upc ? <XText variant='inactive' numberOfLines={1}>{`UPC: ${upc}`}</XText> : null}

                {/* <XText>{`฿${priceText}`}</XText> */}
                {/* <XText>{JSON.stringify(info)}</XText> */}
              </VStack>
            </HStack>
          </HStack>

          <HStack w='full' space='1.5'>
            {/* Column 1 */}
            <VStack w='80px'>
              <HStack h='34px' alignItems='center' justifyContent='flex-end'>
                {/* <XText variant='inactive'>เดิม</XText> */}
              </HStack>

              <HStack h='44px' alignItems='center'>
                <XText w='120px' variant='inactive'>
                  {p.op.t('qty')}
                </XText>
              </HStack>

              <HStack h='34px' alignItems='center'>
                <XText w='120px' variant='inactive'>
                  {p.op.t('available_qty')}
                </XText>
              </HStack>
            </VStack>

            {/* Column 2 */}
            {mode !== 'c' && (
              <VStack flex={1} minW='80px' alignItems='flex-end'>
                <HStack h='34px' w='full' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>เดิม</XText>
                </HStack>

                <HStack h='44px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>{`${currentQty}`}</XText>
                  {changedDiff !== 0 && (
                    <XText bold variant={changedDiff > 0 ? 'success' : 'danger'}>{` ${changedDiff > 0 ? '+' : ''}${changedDiff}`}</XText>
                  )}
                </HStack>

                <HStack h='34px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>{`${availableQty}`}</XText>
                  {changedDiff !== 0 && (
                    <XText bold variant={changedDiff > 0 ? 'success' : 'danger'}>{` ${changedDiff > 0 ? '+' : ''}${changedDiff}`}</XText>
                  )}
                </HStack>
              </VStack>
            )}

            {/* Column 3 */}
            {mode !== 'c' && (
              <VStack maxW='120px' minW='80px' alignItems='flex-end'>
                <HStack h='34px' w='full' alignItems='center' justifyContent='flex-end'>
                  <XText variant='active'>ใหม่</XText>
                </HStack>

                <HStack h='44px' alignItems='center' justifyContent='flex-end'>
                  <XText bold variant='primary'>{`${changedQty}`}</XText>
                </HStack>

                <HStack h='34px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='active'>{`${availableQty + changedDiff}`}</XText>
                </HStack>
              </VStack>
            )}

            {/* Column 2 - for count */}
            {mode === 'c' && (
              <VStack flex={1} minW='80px' alignItems='flex-end'>
                <HStack h='34px' w='full' alignItems='center' justifyContent='flex-end'>
                  <XText variant='active'>นับได้</XText>
                </HStack>

                <HStack h='44px' alignItems='center' justifyContent='flex-end'>
                  <XText bold variant='primary'>{`${changedQty}`}</XText>
                </HStack>

                <HStack h='34px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='active'>{`${availableQty + changedDiff}`}</XText>
                </HStack>
              </VStack>
            )}

            {/* Column 3 - for count */}
            {mode === 'c' && (
              <VStack maxW='120px' minW='80px' alignItems='flex-end'>
                <HStack h='34px' w='full' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>จากเดิมมี</XText>
                </HStack>

                <HStack h='44px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>{`${currentQty}`}</XText>
                </HStack>

                <HStack h='34px' alignItems='center' justifyContent='flex-end'>
                  <XText variant='inactive'>{`${availableQty}`}</XText>
                </HStack>
              </VStack>
            )}
          </HStack>
        </VStack>
      </VStack>
    )

    // return (
    //   <VStack key={`${index}_${id}`} w='full' bg={index % 2 === 0 ? 'white' : 'muted.100'} borderTopWidth='1' borderTopColor='muted.300'>
    //     <HStack w='full' p='2' space='1'>
    //       <VStack w='34px' space='2'>
    //         <XText variant='inactive'>{`#${index + 1}`}</XText>

    //         {/* <XIconButton name='trash' variant='outline' colorScheme='danger' onPress={() => this._onDeleteProductItem(index)} /> */}
    //       </VStack>

    //       <HStack flex={1} space='1'>
    //         <XImage source={{ uri: imgUri }} h='64px' w='64px' borderRadius='lg' />
    //         <VStack flex={1} p='1'>
    //           <XText variant='inactive' numberOfLines={2}>
    //             {productName}
    //           </XText>

    //           <XText numberOfLines={2}>{variantName}</XText>

    //           {sku ? <XText variant='inactive'>{`SKU: ${sku}`}</XText> : null}
    //           {upc ? <XText variant='inactive'>{`UPC: ${upc}`}</XText> : null}

    //           {/* <XText>{`฿${priceText}`}</XText> */}
    //           {/* <XText>{JSON.stringify(info)}</XText> */}
    //         </VStack>
    //       </HStack>

    //       <VStack w='160px' alignItems='flex-end' space='1.5'>
    //         <HStack w='160px'>
    //           <HStack w='80px' justifyContent='flex-end'>
    //             <XText>{`${currentQty}`}</XText>
    //           </HStack>
    //           <HStack w='80px' justifyContent='flex-end'>
    //             <XText>{`${changedQty}`}</XText>
    //           </HStack>
    //         </HStack>

    //         {/* <HStack w='160px' justifyContent='flex-end'>
    //           <TouchableOpacity onPress={() => this._onRequestOpenEditQty(index)}>
    //             <XIcon name='edit' family='FontAwesome' />
    //           </TouchableOpacity>
    //         </HStack> */}
    //       </VStack>
    //     </HStack>
    //   </VStack>
    // )
  }

  _totalQtyChange = () => {
    const products = util.getNavParam(this.props, 'products', [])
    const ppQtyChanged = util.getNavParam(this.props, 'ppQtyChanged', {})

    let totalQtyChanged = 0
    for (const item of products) {
      const pp_id = item.v[0].i
      const currentQty = item.v[0].q || 0
      const changedQty = ppQtyChanged[pp_id]

      totalQtyChanged += changedQty - currentQty
    }

    return totalQtyChanged
  }

  _totalQtyCounted = () => {
    const products = util.getNavParam(this.props, 'products', [])
    const ppQtyChanged = util.getNavParam(this.props, 'ppQtyChanged', {})

    let totalQtyCounted = 0
    for (const item of products) {
      const pp_id = item.v[0].i
      const changedQty = ppQtyChanged[pp_id]

      totalQtyCounted += changedQty
    }

    return totalQtyCounted
  }

  _totalQtyIncreased = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return 0
    }
    const { products } = qtyAdjustmentDetail

    let totalQtyIncreased = 0
    for (const item of products) {
      if (item.qty_adjust > 0) {
        totalQtyIncreased += item.qty_adjust
      }
    }

    return totalQtyIncreased
  }

  _totalQtyDecreased = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return 0
    }

    const { products } = qtyAdjustmentDetail

    let totalQtyDecreased = 0
    for (const item of products) {
      if (item.qty_adjust < 0) {
        totalQtyDecreased += item.qty_adjust
      }
    }

    return totalQtyDecreased
  }

  _getColorScheme = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return 'primary'
    }

    const { mode } = qtyAdjustmentDetail

    let colorScheme = 'primary'

    if (mode === 'a') {
      colorScheme = 'success'
    }

    if (mode === 'd') {
      colorScheme = 'danger'
    }

    if (mode === 's') {
      colorScheme = 'purple'
    }

    if (mode === 'c') {
      colorScheme = 'info'
    }

    return colorScheme
  }

  _getTitle = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return 'ประวัติการปรับจำนวนสินค้า'
    }

    const { mode } = qtyAdjustmentDetail
    let title = ''
    if (mode === 'a') {
      title = 'ประวัติการเพิ่มจำนวนสินค้า'
    }
    if (mode === 'd') {
      title = 'ประวัติการลดจำนวนสินค้า'
    }
    if (mode === 's') {
      title = 'ประวัติการปรับจำนวนสินค้า'
    }
    if (mode === 'c') {
      title = 'ประวัติการนับจำนวนสินค้า'
    }
    return title
  }

  _getCreatedByHelperNameByUserId = (helperUserId: number): string | null => {
    const { selectedStore } = this.props
    if (!selectedStore) {
      return null
    }
    const helpers = selectedStore.get('helpers')
    if (!helpers || helpers.size === 0) {
      return null
    }

    const foundHelper = helpers.find((helper) => helper.get('uid') === helperUserId)
    if (foundHelper && foundHelper.get('n')) {
      return foundHelper.get('n')
    }
    return null
  }

  _renderListHeader = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return null
    }

    if (this.isSearching()) {
      return null
    }

    const { mode, reason, order_id: orderId, ref_code: refCode, note, products, created_at, create_user_id } = qtyAdjustmentDetail
    const totalQtyIncreased = this._totalQtyIncreased()
    const totalQtyDecreased = this._totalQtyDecreased()
    const colorScheme = this._getColorScheme()
    const title = this._getTitle()
    // const titleIcon = util.getNavParam(this.props, 'titleIcon')
    const createdByName = this._getCreatedByHelperNameByUserId(create_user_id)

    return (
      <VStack w='full' p='2'>
        <XCard bg={`${colorScheme}.100`}>
          <VStack w='full' px='3' py='2'>
            <HStack w='full' pt='1' pb='2' alignItems='center' justifyContent='center' space='1'>
              {/* {titleIcon} */}
              <XText pt='2px' color={`${colorScheme}.700`} bold>
                {title}
              </XText>
            </HStack>
            <HStack w='full' space='1'>
              <XText w='220px' fontSize='md' variant='inactive'>
                {'รวมรายการสินค้าที่ถูกแก้ไข: '}
              </XText>
              <XText flex={1} fontSize='md' textAlign='right' variant='active' bold>
                {products.length}
              </XText>
            </HStack>

            {/* <HStack w='full' space='1'>
              <XText w='220px' fontSize='md' variant='inactive'>
                {'รวมจำนวนสินค้าที่ถูกแก้ไข: '}
              </XText>
              <XText flex={1} fontSize='md' textAlign='right' variant='active' bold>
                {totalQtyChanged}
              </XText>
            </HStack> */}

            {mode !== 'd' && (
              <HStack w='full' space='1'>
                <XText w='220px' fontSize='md' variant='inactive'>
                  รวมจำนวนสินค้าที่
                  <XText fontSize='md' variant='success' bold>
                    เพิ่มขึ้น
                  </XText>
                  :
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='success' bold>
                  {totalQtyIncreased > 0 ? `+${totalQtyIncreased}` : totalQtyIncreased}
                </XText>
              </HStack>
            )}

            {mode !== 'a' && (
              <HStack w='full' space='1'>
                <XText w='220px' fontSize='md' variant='inactive'>
                  รวมจำนวนสินค้าที่
                  <XText fontSize='md' variant='danger' bold>
                    ลดลง
                  </XText>
                  :
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='danger' bold>
                  {totalQtyDecreased > 0 ? `-${totalQtyDecreased}` : totalQtyDecreased}
                </XText>
              </HStack>
            )}

            {mode === 'c' && (
              <HStack w='full' space='1'>
                <XText w='220px' fontSize='md' variant='inactive'>
                  รวมจำนวนสินค้าที่
                  <XText fontSize='md' color='info.700' bold>
                    นับได้
                  </XText>
                  :
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' color='info.700' bold>
                  {this._totalQtyCounted()}
                </XText>
              </HStack>
            )}

            {reason && reason.length > 0 && (
              <HStack w='full' space='1'>
                <XText w='180px' fontSize='md' variant='inactive'>
                  {'เหตุผล: '}
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='active'>
                  {reason}
                </XText>
              </HStack>
            )}

            {_.isString(orderId) && orderId.length > 0 && (
              <HStack w='full' space='1'>
                <XText w='180px' variant='inactive'>
                  {'เลขออเดอร์: '}
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='active'>
                  {orderId}
                </XText>
              </HStack>
            )}

            {_.isString(refCode) && refCode.length > 0 && (
              <HStack w='full' space='1'>
                <XText w='180px' variant='inactive'>
                  {'รหัสอ้างอิง: '}
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='active'>
                  {refCode}
                </XText>
              </HStack>
            )}

            {_.isString(note) && note.length > 0 && (
              <HStack w='full' space='1'>
                <XText fontSize='md' variant='inactive'>
                  {'หมายเหตุ: \n'}
                  <XText fontSize='md' variant='active'>
                    {note}
                  </XText>
                </XText>
              </HStack>
            )}

            {created_at && (
              <HStack w='full' space='1'>
                <XText w='180px' fontSize='md' variant='inactive'>
                  {'ดำเนินการเมื่อ'}
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='active'>
                  {time.convertServerDateTimeToReadableDateTimeText(created_at)}
                </XText>
              </HStack>
            )}

            {createdByName && (
              <HStack w='full' space='1'>
                <XText w='180px' fontSize='md' variant='inactive'>
                  {'ดำเนินการโดย'}
                </XText>
                <XText flex={1} fontSize='md' textAlign='right' variant='active'>
                  {createdByName}
                </XText>
              </HStack>
            )}
          </VStack>
        </XCard>
      </VStack>
    )
  }

  _renderProductListContent = () => {
    const { qtyAdjustmentDetail } = this.state
    if (!qtyAdjustmentDetail) {
      return null
    }

    const { products } = qtyAdjustmentDetail
    // if (products.length === 0) {
    //   return null
    // }

    // const isEmptyList = products.length === 0

    return (
      <FlatList
        style={{ flex: 1 }}
        data={products}
        renderItem={this._renderListItem}
        ListHeaderComponent={this._renderListHeader()}
        keyExtractor={(item, index) => `${index}_${item.pt_id}_${item.pp_id}`}
      />
    )
  }

  _renderContent() {
    const { isRefreshing } = this.state

    if (isRefreshing) {
      return (
        <VStack flex={1} w='full' px='2' py='4' justifyContent='center' alignItems='center'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack flex={1} w='full'>
        {this._renderProductListContent()}
      </VStack>
    )
  }

  isSearching = () => {
    const { searchText } = this.state
    return searchText && searchText.length > 0
  }

  isSearchTextMatched = (item: IQtyAdjustProductItem) => {
    const { searchText } = this.state
    if (!searchText || searchText.length === 0) {
      return true
    }

    const lowerSearchText = searchText.toLowerCase()

    const productName = item.product_name || ''
    const variantName = item.variant_name || ''
    const sku = item.sku || ''
    const upc = item.upc || ''

    if (productName.toLowerCase().includes(lowerSearchText)) {
      return true
    }

    if (variantName.toLowerCase().includes(lowerSearchText)) {
      return true
    }

    if (sku.toLowerCase().includes(lowerSearchText)) {
      return true
    }

    if (upc.toLowerCase().includes(lowerSearchText)) {
      return true
    }

    return false
  }

  isNoSearchResult = () => {
    const { qtyAdjustmentDetail, searchText } = this.state
    if (!qtyAdjustmentDetail) {
      return false
    }

    if (!searchText || searchText.length === 0) {
      return false
    }

    const { products } = qtyAdjustmentDetail

    for (const item of products) {
      if (this.isSearchTextMatched(item)) {
        return false
      }
    }

    return true
  }

  getMatechedSearchProducts = () => {
    const { qtyAdjustmentDetail, searchText } = this.state
    if (!qtyAdjustmentDetail) {
      return []
    }

    if (!searchText || searchText.length === 0) {
      return qtyAdjustmentDetail.products
    }

    const matchedItems: IQtyAdjustProductItem[] = []

    const { products } = qtyAdjustmentDetail

    for (const item of products) {
      if (this.isSearchTextMatched(item)) {
        matchedItems.push(item)
      }
    }

    return matchedItems
  }

  _clearSearchText = () => {
    this.setState({ searchText: '' })
  }

  _renderSearchBar = () => {
    const { isInitialized, searchText } = this.state

    if (!isInitialized) {
      return null
    }

    return (
      <VStack w='full' px='2' py='1'>
        <XInput
          value={searchText}
          placeholder='ค้นหา ชื่อสินค้า SKU, UPC ในรายการ...'
          onChangeText={(text) => this.setState({ searchText: text })}
        />

        {this.isSearching() && (
          <HStack position='absolute' right='10px' top='0' bottom='0'>
            <XIconButton name='close' onPress={this._clearSearchText} />
          </HStack>
        )}
      </VStack>
    )
  }

  _renderSearchResultInfo = () => {
    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    if (!this.isSearching()) {
      return null
    }

    const matchedItems = this.getMatechedSearchProducts()

    if (matchedItems.length > 0) {
      return (
        <VStack w='full' px='2' py='2'>
          <XText variant='inactive' textAlign='center'>
            พบผลลัพธ์การค้นหา {matchedItems.length} รายการ
          </XText>
        </VStack>
      )
    }

    return (
      <VStack w='full' px='2' py='2'>
        <XText variant='inactive' textAlign='center'>
          ไม่พบผลลัพธ์การค้นหา
        </XText>
      </VStack>
    )
  }

  render() {
    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return (
      <XContainer>
        {this._renderCustomHeader()}
        {this._renderSearchBar()}
        {this._renderSearchResultInfo()}
        {this._renderContent()}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(QtyAdjustmentDetailView)
